import { _request, APIBaseResponse, APIMethod } from '..';

const REPORTS_TENANTS_PATH_PREFIX = '/reports/tenants';
const USERS_WITH_NEW_ACCESS_BY_ACL_PATH = 'userswithnewaccessbyacl';
const USERS_WITH_NEW_ACCESS_BY_UTM_PATH = 'userswithnewaccessbyutm';

export interface UsersWithNewAccessReportEntry {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    companyKey: string;
    licenseBillingRecord: string;
    userTenantMembershipStartDate: string;
    userTenantMembershipEndDate: string | null;
    aclResourceDisplayName: string;
}

export interface UsersWithNewAccessReportRequest {
    startDate: string;
    endDate: string;
    resourcesIds: string[];
}

export type UsersWithNewAccessReportResponse = APIBaseResponse<UsersWithNewAccessReportEntry[]>;

type APIUsersWithNewAccessParams = {
    tenantId: string;
    request: UsersWithNewAccessReportRequest;
    signal?: AbortSignal;
};

export const APIUsersWithNewAccessByAcl: APIMethod<APIUsersWithNewAccessParams, UsersWithNewAccessReportResponse> =
    ({ tenantId, request, signal }) =>
        _request(
            'POST',
            `${REPORTS_TENANTS_PATH_PREFIX}/${tenantId}/${USERS_WITH_NEW_ACCESS_BY_ACL_PATH}`,
            request,
            signal
        );

export const APIUsersWithNewAccessByUtm: APIMethod<APIUsersWithNewAccessParams, UsersWithNewAccessReportResponse> =
    ({ tenantId, request, signal }) =>
        _request(
            'POST',
            `${REPORTS_TENANTS_PATH_PREFIX}/${tenantId}/${USERS_WITH_NEW_ACCESS_BY_UTM_PATH}`,
            request,
            signal
        );
